<div *ngIf="id || afuConfig.paramsType == 'base64Array'"  class="card-body" style="padding-top: 0">
  <h5 class="card-title d-flex align-items-center"  >
    <img alt="Aggiungi" height="35" width="40" src="assets/images/icon/Allegati@4x.png"/>
    &nbsp;
    ALLEGATI
    &nbsp;
    <span *ngIf="!HideListaFile && collectionSize > 0 && permission.isPermitted('lista-file')"  class="badge badge-info badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
  </h5>

  <div class="row" *ngIf="permission.isPermitted('gestione-file')">
    <div class="col-sm-12">
      <div class="d-flex align-items-center">
        <label>DESCRIZIONE:</label>
        <textarea style="
        border-radius: 15pt;
  background-color: rgba(221, 221, 222, 0.45);
  border-color: #ddddde;
  padding-block: 1em;
  margin-left: 1em;
  margin-bottom: 1em;
  font-family: Roboto;
  color: #525252;
  font-size: 10pt;
" type="text" [(ngModel)]='descrizione' (change)="descrizioneCambiata()"  class="form-control" id="descrizione"></textarea>
      </div>
    </div>
    <div class="col-sm-12">
      <angular-file-uploader #fileUpload  [config]="afuConfig" [(descrizione)]='descrizione' (Base64FilesChange)="Base64FilesOnChange($event)" (onResetClick)="onResetClick()" (onUpdateClick)="Save()" (ApiResponse)="DocUploaded($event)">
      </angular-file-uploader>
    </div>
  </div>
  <hr>
  <div  *ngIf="!HideListaFile && listafile && listafile.length > 0 && permission.isPermitted('lista-file')"  class="row" >
    <table  class=" table bg-white table-hover align-middle mb-0 ">
      <thead>
        <tr>
          <th>Nome</th>
          <th scope="col">Descrizione</th>
          <th scope="col">Data</th>
          <th scope="col">Operatore</th>
          <th scope="col">Azioni</th>
        </tr>
      </thead>
      <tbody >
        <tr *ngFor="let item of listafile">
          <td (click)='download(item)'>
            <span class="text-dark font-medium font-16">{{item.file}}</span>
          </td>
          <td class="align-middle" style="width: 40%; word-break:break-word" (click)='download(item)'>
            <span >{{ item.description }}</span>
          </td>
          <td class="align-middle" (click)='download(item)'>
            <span> {{item.date | date: 'dd/MM/yyyy'}} </span>
          </td>
          <td class="align-middle" (click)='download(item)'>
            <span> <label>{{ item.caricatoDa }}</label></span>
          </td>
          <td class="align-middle">
            <a href="javascript:void(0)" class="link font-16 font-weight-bold" (click)='download(item)'>
              <i-feather name="download" class="feather-sm"></i-feather>
            </a>
            &nbsp;
            <a href="javascript:void(0)" *ngIf="CanDelete" class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
